export enum ProductCategory {
  CampaignPoints = 'campaign_points',
  CardLinkedOffer = 'card_linked_offer',
  CardSpend = 'card_spend',
  GiftCard = 'gift_card',
  ManualAdjustment = 'manual_adjustment',
  PhysicalGiftCard = 'physical_gift_card',
  PointsTransfer = 'points_transfer',
  RedeemCash = 'cash_redemption',
  SystemEvent = 'system_event',
  TravelBooking = 'travel_booking',
  PointsShare = 'points_share',
  AffiliateMall = 'affiliate_mall',
  PurchaseEraser = 'purchase_eraser',
  RealtimeCardSpend = 'realtime_card_spend',
  Merchandise = 'merchandise',
  ShoppingCart = 'shopping_cart',
}
